import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { Button } from '@praetorian-chariot/ui';

import { Tooltip } from '@/components/Tooltip';
import { usePreseedsActions } from '@/hooks/usePreseed';
import { Preseed } from '@/types';

export function PreseedActions({
  label,
  preseeds,
}: {
  label?: boolean;
  preseeds: Preseed[];
}) {
  const { onApprove, onReject, canApprove, isManagedAccount } =
    usePreseedsActions();
  return (
    <div
      data-testid="bulk-actions"
      className="flex items-center justify-center gap-3"
    >
      {label && <p className="font-semibold">Actions: </p>}
      <Tooltip
        title={
          !canApprove
            ? isManagedAccount
              ? 'Only the Managed Services team may approve preseed attributes'
              : 'Upgrade to enable scanning of discovered attributes'
            : ''
        }
        placement="top"
      >
        <div className={!canApprove ? 'cursor-not-allowed' : ''}>
          <Button
            label="Approve"
            startIcon={<CheckCircleIcon className="size-5 cursor-pointer" />}
            onClick={() => onApprove(preseeds)}
            styleType="rounded"
            size="xs"
            disabled={!canApprove}
          />
        </div>
      </Tooltip>
      <Button
        label="Reject"
        startIcon={<XCircleIcon className="size-5 cursor-pointer" />}
        onClick={() => onReject(preseeds)}
        styleType="rounded"
        size="xs"
      />
    </div>
  );
}
